/******** Theme Scripts *********/
import AOS from "aos";
AOS.init({
  duration: 1000,
  once: false,
  mirror: true,
});

/**
 * Represents a collection of h1 elements.
 * 
 * @type {NodeList.<HTMLHeadingElement>}
 */
const h1Elements = document.querySelectorAll('h1');

/**
 * Replaces all h1 elements (except the first one) with div elements of class 'display-large'.
 * This maintains the visual hierarchy while adjusting the semantic structure.
 */
h1Elements.forEach((h1, index) => {
  if (index === 0) {
    return;
  }
  const div = document.createElement('div');
  div.className = 'display-large';
  div.innerHTML = h1.innerHTML;
  div.style.cssText = h1.style.cssText;
  div.classList.add(...h1.classList);
  h1.replaceWith(div);
});



/**
 * Calculates the contrast color (black or white) based on the given hex color.
 *
 * @param {string} hexColor - The hex color code.
 * @returns {string} The contrast color ('#000' for black or '#fff' for white).
 */
const getContrastYIQ = (hexColor) => {
  const r = parseInt(hexColor.substr(1, 2), 16);
  const g = parseInt(hexColor.substr(3, 2), 16);
  const b = parseInt(hexColor.substr(5, 2), 16);
  const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
  console.log(yiq);
  return yiq >= 130 ? '#000' : '#fff';
};



/**
 * Converts an RGB color string to its hexadecimal representation.
 *
 * @param {string} rgb - The RGB color string (e.g., "rgb(255, 255, 255)").
 * @returns {string} The hexadecimal color code.
 */
const rgbToHex = (rgb) => {
  const [r, g, b] = rgb.match(/\d+/g);
  const hex = ((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1);
  return `#${hex}`;
};



/**
 * Sets the text color of all elements inside the given app based on its background color.
 * 
 * @param {HTMLElement} unique_id - The unique identifier of the app.
 * @returns {void}
 */
const setTextColorBasedOnBackground = (unique_id) => {
  const app = unique_id;
  const color = app.style.backgroundColor;
  if (!color) {
    return;
  }
  const hexColor = rgbToHex(color);

  const textColor = getContrastYIQ(hexColor);
  
  const elements = app.querySelectorAll('*');
  const exempt = ['button', 'a', 'input', 'select', 'textarea', 'h6', 'span'];
  elements.forEach(element => {
    if (exempt.includes(element.tagName.toLowerCase())) {
      return;
    }
    element.style.color = textColor;
  });
}



/**
 * Applies text color based on background for all column modules.
 */
const columnModules = document.querySelectorAll('.column-module');
columnModules.forEach(columnModule => {
  setTextColorBasedOnBackground(columnModule);
});


/**
 * Represents a collection of accordion items.
 * @type {NodeList}
 */
const accordionItems = document.querySelectorAll('.accordion-item');
accordionItems.forEach(item => {
    item.addEventListener('click', function (event) {
        // Check if the click occurred within .accordion-content
        if (!event.target.closest('.accordion-content')) {
            // Toggle active class on the clicked item
            item.classList.toggle('active');
            // Close other items
            accordionItems.forEach(otherItem => {
                if (otherItem !== item) {
                    otherItem.classList.remove('active');
                }
            });
            // Scroll to the active item with an offset of about 100px
            if (item.classList.contains('active')) {
                const yOffset = -300; // 300px offset
                const y = item.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({top: y, behavior: 'smooth'});
            }
    }
  });
});



/**
 * Initializes Swiper for swiper containers if they exist.
 */
const swiperContainers = document.querySelectorAll('.swiper-container');
if (swiperContainers.length > 0) {
  import('./swiper-init');
}



/**
 * Video Testimonials
 */

document.addEventListener('DOMContentLoaded', function() {
  const videoWrappers = document.querySelectorAll('.video-wrapper');

  videoWrappers.forEach(wrapper => {
    const video = wrapper.querySelector('video');
    if (!video) {
      return;
    }
    const playButton = wrapper.querySelector('.play-button');
    if (!playButton) {
      return;
    }

    playButton.addEventListener('click', function() {
      video.controls = true;
      video.play();
      playButton.style.display = 'none';
    });

    video.addEventListener('play', function() {
      video.controls = true;
      playButton.style.display = 'none';
    });

    video.addEventListener('pause', function() {
      if (video.ended) {
        video.controls = false;
      }
      playButton.style.display = 'block';
    });

    video.addEventListener('ended', function() {
      video.controls = false;
      playButton.style.display = 'block';
    });

    // Hide controls when mouse leaves video area
    wrapper.addEventListener('mouseleave', function() {
      if (!video.paused) {
        video.controls = false;
      }
    });

    // Show controls when mouse enters video area
    wrapper.addEventListener('mouseenter', function() {
      if (!video.paused) {
        video.controls = true;
      }
    });
  });
});

/**
 * Full Media To Video Controls
 */
document.addEventListener('DOMContentLoaded', function() {
  // Initialize video controls for full-media-to components
  initFullMediaVideoControls();
});

/**
 * Initialize video controls functionality for full-media-to components
 */
function initFullMediaVideoControls() {
  const playPauseButtons = document.querySelectorAll('.full-media-to .play-pause-btn');
  
  playPauseButtons.forEach(button => {
    const videoId = button.getAttribute('data-video-id');
    const video = document.getElementById(videoId);
    const icon = button.querySelector('i');
    
    if (!video || !icon) return;
    
    // Handle button click
    button.addEventListener('click', function() {
      toggleFullMediaPlayPause(video, icon);
    });
    
    // Update button state when video state changes
    video.addEventListener('play', function() {
      updateFullMediaIcon(icon, true);
    });
    
    video.addEventListener('pause', function() {
      updateFullMediaIcon(icon, false);
    });
    
    // Set initial icon state based on video state
    updateFullMediaIcon(icon, !video.paused);
  });
}

/**
 * Toggle video play/pause state for full-media-to components
 */
function toggleFullMediaPlayPause(video, icon) {
  if (video.paused) {
    video.play().catch(e => {
      console.warn('Failed to play video:', e);
    });
  } else {
    video.pause();
  }
}

/**
 * Update the button icon based on play state for full-media-to components
 */
function updateFullMediaIcon(icon, isPlaying) {
  if (isPlaying) {
    icon.className = 'fas fa-pause';
  } else {
    icon.className = 'fas fa-play';
  }
}

/**
 * Full Media To Component Animation (Apple-style clip-path)
 */
document.addEventListener('DOMContentLoaded', function() {
  // GSAP is available globally via webpack bundle
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    console.warn('GSAP or ScrollTrigger not available - make sure main.js is loaded');
    return;
  }
  
  // Find all full media to sections
  const mediaSections = document.querySelectorAll('.full-media-to:not(.is-preview)');
  
  mediaSections.forEach(function(section) {
    const mediaContent = section.querySelector('.media-content');
    
    if (mediaContent && section) {
      // Create the clip-path animation
      gsap.fromTo(mediaContent, 
        {
          // Starting state - no clipping (full size)
          clipPath: "inset(0%)"
        },
        {
          // Ending state - clipped with rounded corners
          clipPath: "inset(6.25% round 44px)",
          ease: "power2.out",
          scrollTrigger: {
            trigger: section,
            start: "top center", // Start when section enters center of viewport
            end: "bottom center", // End when section exits center of viewport
            scrub: 1.5, // Smooth scrubbing with slight lag
            onUpdate: function(self) {
              // Optional: Add any additional effects during scroll
              const progress = self.progress;
              
              // Example: Subtle scale effect (optional)
              // const scale = 1 + (progress * 0.02); // Scale up slightly as it clips
              // gsap.set(mediaContent, { scale: scale });
            },
            onComplete: function() {
              console.log('Media clip animation complete');
            }
          }
        }
      );
      
      // Mobile version with different values
      if (window.innerWidth <= 768) {
        // Update the animation for mobile with different clip values
        gsap.to(mediaContent, {
          clipPath: "inset(3% round 20px)",
          scrollTrigger: {
            trigger: section,
            start: "top center",
            end: "bottom center",
            scrub: 1.5,
          }
        });
      }
    }
  });
  
  // Refresh ScrollTrigger on window resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      ScrollTrigger.refresh();
    }, 250);
  });
});

/**
 * Full Screen to Laptop Component Animation
 */
document.addEventListener('DOMContentLoaded', function() {
  // GSAP is available globally via webpack bundle
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    console.warn('GSAP or ScrollTrigger not available - make sure main.js is loaded');
    return;
  }
  
  // Skip all animations on mobile - keep it static
  if (window.innerWidth <= 768) {
    console.log('Mobile detected - laptop component will remain static');
    return;
  }
  
  // Find all full screen to laptop sections
  const laptopSections = document.querySelectorAll('.full-screen-to-laptop:not(.is-preview)');
  
  laptopSections.forEach(function(section) {
    const laptopWrapper = section.querySelector('.laptop-zoom-wrapper');
    
    if (laptopWrapper && section) {
      // Set initial state with hardware acceleration
      gsap.set(laptopWrapper, {
        scale: 1.8,
        y: "-8%",
        z: 0,
        transformOrigin: "center center",
        force3D: true
      });
      
      // Create the zoom-out animation with improved settings
      gsap.to(laptopWrapper, {
        // Ending state - normal scale and position
        scale: 1,
        y: "0%",
        z: 0,
        transformOrigin: "center center",
        ease: "power1.out", // Gentler easing for smoother motion
        force3D: true, // Hardware acceleration
        scrollTrigger: {
          trigger: section,
          start: "top top",
          end: "bottom center",
          scrub: 0.8, // Reduced from 1.2 for more responsive scrolling
          pin: true,
          pinSpacing: false,
          anticipatePin: 1,
          fastScrollEnd: true, // Improve fast scroll performance
          refreshPriority: -1, // Lower priority for smoother scrolling
          onUpdate: function(self) {
            // Removed the breathing effect to eliminate unnecessary movement
            // This prevents jarring during fast scrolling
            
            // Optional: Add subtle opacity fade for focus effect instead
            const progress = self.progress;
            const opacity = 0.85 + (progress * 0.15); // Subtle opacity change
            gsap.set(laptopWrapper, { opacity: opacity });
          },
          onToggle: function(self) {
            // Smooth pin/unpin transitions
            if (self.isActive) {
              gsap.set(section, { zIndex: 100 });
            } else {
              gsap.set(section, { zIndex: 1 });
            }
          },
          onComplete: function() {
            console.log('Laptop zoom animation complete');
            // Removed the complex second ScrollTrigger that was causing layout jumps
            // Instead, add a simple subtle glow effect
            gsap.to(laptopWrapper, {
              boxShadow: '0 0 60px rgba(255, 255, 255, 0.1)',
              duration: 1,
              ease: "power2.out"
            });
          }
        }
      });
    }
  });
  
  // Optimized resize handler with debouncing
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      // Only refresh if not mobile and window size changed significantly
      if (window.innerWidth > 768) {
        ScrollTrigger.refresh();
      }
    }, 150); // Reduced timeout for more responsive resizing
  });
  
  // Add scroll performance optimization
  let ticking = false;
  function updateScrollPerformance() {
    if (!ticking) {
      requestAnimationFrame(function() {
        // Optimize scroll performance for this component
        laptopSections.forEach(function(section) {
          const rect = section.getBoundingClientRect();
          const inViewport = rect.top < window.innerHeight && rect.bottom > 0;
          
          if (inViewport) {
            section.style.willChange = 'transform';
          } else {
            section.style.willChange = 'auto';
          }
        });
        ticking = false;
      });
      ticking = true;
    }
  }
  
  window.addEventListener('scroll', updateScrollPerformance, { passive: true });
});





